<template>
  <div id="combo_buyCombo">
    <mt-header title="套餐列表">
      <mt-button icon="back" slot="left" @click="goBack">返回</mt-button>
    </mt-header>

    <div style="padding-bottom: 8px;">
      <ul>
        <li v-for="(item, index) in itemsCombo">
          <div class="combo-buyCombo-view">
            <div class="combo-buyCombo-view-name">
              <div><span>{{item.name}}</span></div>
            </div>
            <hr>
            <div class="combo-buyCombo-view-mid">
              <div class="combo-buyCombo-view-price"><span>￥{{item.price}}</span></div>
              <div class="combo-buyCombo-view-frequency">
              	<span v-if="item.paidMode != '2'">/{{item.number}}次</span>
              	<span v-if="item.paidMode == '2'">/有效期{{item.days}}天</span>
              	<span v-if="item.paidMode == '3'" class="combo-buyCombo-view-validity"> ( 有效期{{item.days}}天 )</span>
              </div>
            </div>
            <div style="text-align: center">
              <span v-if="item.paidMode == '1'">计费模式:次数</span>
              <span v-if="item.paidMode == '2'">计费模式:天数</span>
              <span v-if="item.paidMode == '3'">计费模式:次数与天数</span>
            </div>
            <div class="combo-buyCombo-view-buyCombo">
              <mt-button class="login-btn" size="large" type="primary" @click="buyCombo(item.id)">购买套餐</mt-button>
            </div>
          </div>
        </li>
      </ul>

    </div>

    <div id="payId">
    </div>
  </div>

</template>
<script>
  import {Toast} from 'mint-ui';
  import cheader from '@/components/header';
  export default {
    data () {
      return {
        itemsCombo: [1, 2, 3, 4, 5, 6],
        num: 30,
        paidMode: '次数'
      }
    },
    methods: {
      goBack: function () {
        history.go(-1); //后退1页
      },
      fetcchMsg(){
        var _comboListsync_url = domain("_comboListsync");
        var that = this;
        that.$http.post(
          _comboListsync_url,
          {emulateJSON: true}
          )
          .then(function (response) {  //接口返回数据
          console.log(response)
            this.itemsCombo = response.data.data.rows;
          }, function (error) {
            //Toast("数据获取响应异常.")
          }).catch(function (response) {
          //Toast("数据获取响应异常.")
          Indicator.close();
        })
      },
      buyCombo: function (id) {
     //   Toast("暂无法支付.");

       this.$router.push({
         path: "/combo/createOrder",
         name: 'createOrder',
         query:{
           id:id
         }
       })

      }
    },
    components: {},
    mounted: function () {
      this.fetcchMsg();
    }

  }
</script>
<style>
  #combo_buyCombo {
    background-color: #ECECEC;
    width: 100%;
    min-height: 100%;
  }

  #reminderImg {
    width: 15px;
    height: 15px;
    float: left;
    margin-top: 0.5rem;
    margin-left: 1rem;
    padding-right: 0.5rem;
  }

  .combo-title {
    display: block;
    font-size: 0.8rem;
    color: #c1c1c1;
    font-family: "Microsoft YaHei";
    line-height: 2rem;
  }

  .combo-buyCombo-view {
    margin-left: 4%;
    margin-right: 4%;
    background-color: #ffffff;
    font-size: 1rem;
    color: #7d7d7d;
    font-family: "Microsoft YaHei";
    border-radius: 5px;
    margin-top: 0.4rem;

  }

  .combo-buyCombo-view-name {
    padding: 10px 0;
    text-align: center;
    font-size: 1.1rem;
  }

  .combo-buyCombo-view-price {
    display: inline;
    font-weight: bolder;
  }
  .combo-buyCombo-view-price span{
    font-size: 1.1rem;
  }
  .combo-buyCombo-view-frequency {
    display: inline;
    color: #c1c1c1;
  }

  .combo-buyCombo-view-validity {
    margin-left: 5px;
  }

  .combo-buyCombo-view-buyCombo {
    width: 90%;
    margin: auto;
    margin-top: 0.5rem;
    padding-bottom: 1rem;
  }
  .combo-buyCombo-view-mid{
    text-align: center;
    margin: 10px 0;
  }
</style>



// WEBPACK FOOTER //
// src/module/combo/BuyCombo.vue